// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__IiEfY"};
module.exports.__checksum = "64821cd54951"
